import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer whitespace-nowrap">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">桃子影院</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              桃子影院，您的免费在线观影平台。最新电影、热门电影、高清蓝光4K影视，永久免费不缓冲，秒开播放。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">电影大全</Link>
              <Link to="/category/huayu" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">华语电影</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">电影分类</h4>
            <div className="flex flex-wrap gap-2">
              {movieCategories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 rounded-md text-xs bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <span className="flex items-center gap-2 whitespace-nowrap">
                <i className="ri-mail-line"></i> contact@taozicinema.com
              </span>
              <span className="flex items-center gap-2 whitespace-nowrap">
                <i className="ri-phone-line"></i> 400-888-6666
              </span>
              <span className="flex items-center gap-2 whitespace-nowrap">
                <i className="ri-map-pin-line"></i> 北京市朝阳区影视产业园
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 桃子影院 Taozicinema.com - 永久免费在线观看高清电影
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}